<template>
  <div>
    <v-row class="mb-4">
      <v-col cols="12" md="4">
        <v-card border>
          <v-card-text>
            <div
              class="text-uppercase text-disabled font-size-11 font-weight-bold mb-2">
              Всього днів за рік
            </div>
            <div class="font-size-24 font-weight-bold">
              {{ vacationStats.total }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card border color="amber-lighten-5">
          <v-card-text>
            <div
              class="text-uppercase font-size-11 font-weight-bold mb-2 text-amber-darken-3">
              Використано + заплановано
            </div>
            <div class="font-size-24 font-weight-bold text-amber-darken-3">
              {{ vacationStats.used }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card border color="green-lighten-5">
          <v-card-text>
            <div
              class="text-uppercase font-size-11 font-weight-bold mb-2 text-success">
              Доступно
            </div>
            <div class="font-size-24 font-weight-bold text-success">
              {{ vacationStats.available }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="label mb-4">Список відпусток</div>

    <v-data-table
      :headers="headers"
      :hide-default-footer="true"
      :items="vacationRows"
      :items-per-page="-1">
      <template #item.days="{ item }">
        <span class="font-weight-bold">{{ item.days }}</span>
      </template>
      <template #item.status="{ item }">
        <v-chip
          color="green-lighten-5"
          density="comfortable"
          rounded="lg"
          size="small"
          variant="flat">
          <span class="font-weight-bold text-green-darken-3">
            {{ item.status }}
          </span>
        </v-chip>
      </template>
      <template #bottom></template>
    </v-data-table>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useUserCardVacationsStore } from '@/dialog/components/user-card/tabs/vacations/vacations'

export default {
  name: 'UserCardVacations',
  setup() {
    const store = useUserCardVacationsStore()
    const headers = ref([
      { key: 'type', title: 'Тип' },
      { key: 'startDate', title: 'З' },
      { key: 'endDate', title: 'По' },
      { key: 'days', title: 'Днів' },
      { key: 'deputy', title: 'Заміщує' },
      { key: 'status', title: 'Статус' },
    ])

    return { ...store, headers }
  },
}
</script>
